import 'xterm/css/xterm.css'
import React, { useEffect, useState, useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Terminal } from 'xterm'
import { FitAddon } from 'xterm-addon-fit'

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
  },
  ssh: {
    width: '100%',
    height: '100%',
    backgroundColor: '#000'
  }
}))

const Logs = ({
  logs,
}) => {
  const classes = useStyles()
  const [ lines, setLines ] = useState([])
  const rootDom = useRef()
  const dom = useRef()
  const terminal = useRef()

  useEffect(() => {
    if(!terminal.current) {
      dom.current.style.height = rootDom.current.clientHeight + 'px'
      terminal.current = new Terminal()
      const fitAddon = new FitAddon()
      terminal.current.loadAddon(fitAddon)
      terminal.current.open(dom.current)
      fitAddon.fit()
    }
    logs.slice(lines.length).forEach(log => terminal.current.write(log + "\r\n"))
    setLines(logs)
  }, [
    logs,
  ])

  return (
    <div className={ classes.root } ref={ rootDom }>
      <div className={ classes.ssh } ref={ dom }>
      </div>
    </div>
  )
}

export default Logs
